// ESM-Huelle um lib/scripts/pos/CLS_CRebateEngine.js (Phase 4, Welle 3) -
// Rabattlogik, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var factor, ref;


function CRebateEngine() {}

CRebateEngine.prototype.extractRebateSum = function () {
    var BonManagerClass = this;
    var dfd = jQuery.Deferred();
    $.when(Trans.getPPCProduct()).then(function (PPCProd) {
        var rebSum = 0;

        for (var i in BonManagerClass.currentBon) {
            var e = BonManagerClass.currentBon[i];

            if (e.type != "POS" || e.cancelled || e.productId == PPCProd || e.product.correctedPrice > e.product.price)
                continue;

            var applyRebate = true;
            if (BonManagerClass.isProductRebate[i]) {
                applyRebate = false;
            }
            for (ref in e.referencedBy) {
                var refType = e.referencedBy[ref].type
                    if (refType == "MRB" || refType == "ARB") {
                        applyRebate = false;
                        break;
                    }
            }
            if (applyRebate) {
                rebSum += e.amount;
            }
        }
        dfd.resolve(rebSum);
    });
    return dfd.promise();
}

CRebateEngine.prototype.updateInstantRebate = function (is33) {
    var BonManagerClass = this;
    var defret = $.Deferred();

    if (this.isPPCCharge(false, is33)) {
        return 0;
    }

    if (this.currentCustomerId && ((this.currentCustomerId < 1115000000000) || (this.currentCustomerId >= 1120000000000))) {
        $.when(this.extractRebateSum()).then(function (rebSum) {

            var rebate = 0;
            for (var i in BonManagerClass.rebateZones) {
                var rZ = BonManagerClass.rebateZones[i];
                rebate = rZ.getRebate(rebSum);
                if (rebate)
                    break;
            }

            BonManagerClass.currentIRBSum = rebSum;
            BonManagerClass.currentIRBPercent = rebate * 100;
            var absReb = rebSum - fix2Decimals(rebSum * (1 - rebate));
            var bonSum = BonManagerClass.getSumArray()[1];
            var relReb = absReb / bonSum;
            if (isNaN(relReb))
                relReb = 0;
            $.when(BonManagerClass.addEntrySubREBS("IRB", relReb )).then(function () {
                defret.resolve();
            });
        });
    } else {
        var Entry = null;
        for (var Cnt in this.currentBon) {
            var EntryTmp = this.currentBon[Cnt];
            if ((EntryTmp.type == "GRB") && !(EntryTmp.cancelled) && ((EntryTmp.text2 == "IRB") || (EntryTmp.text2 == "IDC"))) {
                Entry = EntryTmp;
                break;
            }
        }
        if (Entry) {
            if (Entry.text2 == "IRB") {
                $.when(BonManagerClass.grantRebPercentFromTotal(BonManagerClass.currentIRBPercent / 100, 0, Entry.text1)).then(function () {
                    defret.resolve();
                    return;
                })
            } else if (Entry.text2 == "IDC") {
                $.when(BonManagerClass.grantRebAbsoluteFromTotal(Entry.quantity, is33, 0, Entry.text1)).then(function () {
                    defret.resolve();
                    return;
                })
            }
        }
        defret.resolve();
    }
    return defret.promise();
}

CRebateEngine.prototype.findActiveRebateEntry = function () {
    for (var Cnt in this.currentBon) {
        var Entry = this.currentBon[Cnt];
        if (!Entry || Entry.cancelled) continue;
        if (Entry.type == "MRB" || Entry.type == "ARB" || Entry.type == "GRB" || Entry.type == "CRB") {
            return Entry;
        }
    }
    return null;
};

CRebateEngine.prototype.addEntryMRB = function (reference, quantity, amount, superBonId, rebName) {
    var Entry;
    var updateIt;
    var BonManagerClass = this;
    var def = jQuery.Deferred();
    var defret = jQuery.Deferred();

    if (BonManagerClass.isPPCCharge() && (rebName && rebName != "Lucky Number")) {
        POS.message.show("Auf dieses Produkt gibt es keinen Rabatt", "warning", "OK");
        return 0;
    }

    if (!reference) {
        var text = POS.lang.getText("MESSAGES", "NO_REBATE_REFERENCE");
        POS.message.show(text, "warning", "OK");
        return 0;
    }
    if (quantity == -1 && amount == "") {
        text = POS.lang.getText("MESSAGES", "NO_REBATE_AMOUNT");
        POS.message.show(text, "warning", "OK");
        return 0;
    }
    if (amount == -1 && quantity == "") {
        text = POS.lang.getText("MESSAGES", "NO_REBATE_PERCENT");
        POS.message.show(text, "warning", "OK");
        return 0;
    }

    if (quantity == -1)
        quantity = 0;
    if (amount == -1)
        amount = 0;

    var newamount = reference.amount;

    // look if reference already exists
    for (var Cnt in this.currentBon) {
        Entry = this.currentBon[Cnt];
        if ((Entry.type == "MRB" || Entry.type == "ARB") && !Entry.cancelled && Entry.reference == reference && Entry.valid) {
            updateIt = true;
        }
        //bei bereits erfolgtem Rabatt soll nur von der Nettosumme der zusätzliche Rabatt genommen werden
        if ((amount == 0) && Entry == reference && ((Entry.referencedBy) && (Entry.referencedBy.length > 0))) {
            factor = 1;
            for (var RefKey in Entry.referencedBy) {
                var Ref = Entry.referencedBy[RefKey];
                if ((Ref.type == "MRB") && (Ref.quantity < 1)) {
                    if (Ref.productId == superBonId) {
                        text = "Es kann nicht derselbe Rabattcode mehrmals angewendet werden!"
                        POS.message.show(text, "critical", "OK");
                        return 0;
                    }
                    newamount = newamount + Ref.amount;
                } else if (Ref.type == "ARB") {
                    text = "Es kann kein weiterer Rabattcode angewendet werden!"
                    POS.message.show(text, "critical", "OK");
                    return 0;
                }
            }
        }
    }
    if (!updateIt) {
        var blocking = BonManagerClass.findActiveRebateEntry();
        if (blocking) {
            text = "Es ist bereits ein Rabatt auf diesem Bon vorhanden (" + (blocking.text1 || blocking.type) + "). Bitte zuerst entfernen.";
            POS.message.show(text, "critical", "OK");
            return 0;
        }
    }
    if (reference.type != "POS") {
        text = POS.lang.getText("MESSAGES", "NO_REBATE_POS_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return 0;
    }
    if (!reference.product) {
        text = POS.lang.getText("MESSAGES", "NO_REBATE_PRODUCT");
        POS.message.show(text, "critical", "OK");
        return 0;
    }
    $.when(Trans.getProductData(reference.productId)).done(function (Product) {
        if (!Product.valid) {
            text = POS.lang.getText("MESSAGES", "NO_REBATE_VALID_PRODUCT");
            POS.message.show(text, "critical", "OK");
            def.reject();
            defret.resolve();
            return;
        }
        var rebateAmount = quantity ? (quantity * newamount) : amount;
        var rebStr = float2StringD2(rebateAmount);

        // Check Price with rebate margins and user rights
        if (!BonManagerClass.overridePriv) {
            if (quantity && quantity > BonManagerClass.userProps.MaxRebate) {
                text = POS.lang.getText("MESSAGES", "TOO_HIGH_USER_REBATE");
                text += BonManagerClass.userProps.MaxRebate * 100 + "%.";
                POS.message.show(text, "warning", "OK");
                def.reject();
                defret.resolve();
                return;
            }
            if (quantity && quantity > Product.rebateMargin) {
                text = POS.lang.getText("MESSAGES", "TOO_HIGH_PRODUCT_REBATE");
                text += float2StringD2(Product.rebateMargin * 100) + "%.";
                POS.message.show(text, "warning", "OK");
                def.reject();
                defret.resolve();
                return;
            }
            if (amount > fix2Decimals(reference.amount * BonManagerClass.userProps.MaxRebate)) {
                text = POS.lang.getText("MESSAGES", "TOO_HIGH_USER_REBATE");
                text += float2StringD2(reference.amount * BonManagerClass.userProps.MaxRebate) + " Euro.";
                POS.message.show(text, "warning", "OK");
                def.reject();
                defret.resolve();
                return;
            }
        } else
            BonManagerClass.overridePriv = false;

        // ok, add rebate
        if (updateIt) {
            Entry.quantity = quantity;
            Entry.amount = fix2Decimals(rebateAmount * -1);
            Entry.text1 = rebName;
            $.when(Trans.updateEntry(Entry, "MRB")).done(function () {
                def.resolve();
            });
        } else {
            // create BonEntry
            BonManagerClass.currentIndex++;
            var PrimBonEntry = new CBonEntry(BonManagerClass.currentIndex, "MRB", "NIL", quantity, rebName,
                    "",
                    reference, fix2Decimals(rebateAmount * -1), null, superBonId ? superBonId : null, false);
            // DB
            $.when(PrimBonEntry.defreturn).done(function (c) {
                $.when(Trans.addEntry(BonManagerClass.currentBonId, PrimBonEntry)).done(function (id) {
                    // Add BonEntry to Bon
                    BonManagerClass.currentBon[BonManagerClass.currentIndex] = PrimBonEntry;
                    reference.referencedBy[BonManagerClass.currentIndex] = PrimBonEntry;
                    def.resolve();
                });
            });
        }
    });
    $.when(def).done(function () {
        BonManagerClass.redrawBonArray[reference.index] = reference;
        $.when(BonManagerClass.redrawBonSum()).done(function () {
            $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                BonManagerClass.showPos(reference, false);
                // FEHLER 25.8.2026, vom Nutzer auf der Dev-Kasse gesehen: ein
                // Rabatt macht die betroffene Bonzeile HOEHER (zusaetzlich
                // "Artikel - 50%" und der Rabattbetrag). Der Bon-Container hat
                // feste Hoehe und overflow:hidden, gescrollt wird per
                // scrollTop - und das tat bisher NUR der Pfad, der eine Zeile
                // HINZUFUEGT (bonentryops.js: scrollAbs nach dem Neuzeichnen).
                // Waechst dagegen eine BESTEHENDE Zeile, blieb scrollTop stehen
                // (gemessen: scrollTop 9, moeglich waeren 49) und der
                // Summenblock rutschte unter die Containerkante - die Summe
                // war nicht mehr lesbar. Altes Verhalten, keine Folge des
                // React-Umbaus (Historie geprueft).
                // Gleicher Aufruf wie im Hinzufuegen-Pfad: ans Ende scrollen.
                BonManagerClass.Bon.scrollAbs(10000000);
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

CRebateEngine.prototype.addEntryCDS = function (quantity, refBonId) {
    var BonManagerClass = this;
    var defret = $.Deferred();
    $.when(Trans.getPosBonId(refBonId)).then(function (bonId) {
        $.when(BonManagerClass.addEntrySubREBS("CDS", quantity, false, bonId)).done(function () {
            defret.resolve();
        });
    });
    return defret.promise();
}

CRebateEngine.prototype.addEntryGRB = function (quantity, isPPU, ignoreMax) {

    if (this.isPPCCharge()) {
        return 0;
    }
    var blocking = this.findActiveRebateEntry();
    if (blocking && blocking.type != "GRB") {
        var text = "Es ist bereits ein Rabatt auf diesem Bon vorhanden (" + (blocking.text1 || blocking.type) + "). Bitte zuerst entfernen.";
        POS.message.show(text, "critical", "OK");
        return 0;
    }
    return this.addEntrySubREBS("GRB", quantity, isPPU);
}

CRebateEngine.prototype.addEntryCRB = function () {
    var BonManagerClass = this;
    $.when(Trans.getCustomerRebate(this.currentCustomerId)).then(function (quantity) {
        $.when(BonManagerClass.addEntrySubREBS("CRB", quantity)).done(function () {

            for (var Cnt in BonManagerClass.currentBon) {
                var Entry = BonManagerClass.currentBon[Cnt];
                if (Entry.type == "GRB" && !Entry.cancelled) {
                    var GRB = Entry.quantity;
                    var text = Entry.text1;
                    var found = true;
                    break;
                }
            }

            if (!found)
                return;

            if (GRB + quantity > BonManagerClass.userProps.MaxGlobalRebate) {
                Entry.quantity = BonManagerClass.userProps.MaxGlobalRebate - quantity;
                Entry.text1 = text + (Entry.quantity * 100).toFixed(2) + " %:";
                $.when(Trans.updateEntry(Entry, "GRB")).done(function () {
                    $.when(BonManagerClass.redrawBonSum()).done(function () {
                        BonManagerClass.showSum();

                        text = POS.lang.getText("MESSAGES", "GLOBAL_REBATE_CORRECTED");
                        text += float2StringD2((BonManagerClass.userProps.MaxGlobalRebate - quantity) * 100) +
                        "%.";
                        POS.message.show(text, "warning", "OK");
                    });
                });
            }
        });
    });
}

CRebateEngine.prototype.addEntrySubREBS = function (type, quantity, isPPU, refBillId, eurORperc, rebid) {
    var Entry;
    var updateIt;
    var PrimBonEntry;
    var def = $.Deferred();
    var BonManagerClass = this;
    var defret = $.Deferred();
    var inEUR = false;
    var inPERC = false;

    if (type == "IRB") {
        // GRB with no max limit
        if ((eurORperc) && (eurORperc == "EUR")) {
            inEUR = true;
            inPERC = false;
        } else if (eurORperc) {
            inPERC = true;
            inEUR = false;
        }
        type = "GRB";
        var isInstantRebate = true;
    } else
        isInstantRebate = false;

    if (BonManagerClass.currentBonId == 0)
        return 0;

    if (typeof quantity == "undefined") {
        var text = POS.lang.getText("MESSAGES", "NO_AMOUNT");
        POS.message.show(text, "warning", "OK");
        return 0;
    }

    if ((type == "CDS") && this.isCashPayment()) {
        var def2 = Trans.getPosREGId(refBillId);
    } else {
        def2 = 0;
    }
    $.when(def2).done(function (POSREG_ID) {
        var b_id = POSREG_ID;
        if (!POSREG_ID)
            b_id = refBillId;
        var text = (type == "GRB" ? "Rabatt " :
            (type == "CDS" ? "Gutschrift Rechn.nr. " + b_id :
                (type == "CRB" ? "Kundenrabatt" : "")));

        for (var Cnt in BonManagerClass.currentBon) {
            Entry = BonManagerClass.currentBon[Cnt];
            if (Entry.type == type && !Entry.cancelled) {
                updateIt = true;
                break;
            }
        }

        if (isInstantRebate && quantity == 0 && !updateIt) {
            defret.resolve();
            def.reject();
            return 0;
        }

        if (!quantity && !updateIt) {
            var text = POS.lang.getText("MESSAGES", "NO_AMOUNT");
            POS.message.show(text, "warning", "OK");
            defret.resolve();
            def.reject();
            return 0;
        }

        if (!updateIt && type != "CDS") {
            var blocking = BonManagerClass.findActiveRebateEntry();
            if (blocking && blocking.type != type) {
                text = "Es ist bereits ein Rabatt auf diesem Bon vorhanden (" + (blocking.text1 || blocking.type) + "). Bitte zuerst entfernen.";
                POS.message.show(text, "critical", "OK");
                defret.resolve();
                def.reject();
                return 0;
            }
        }

        if (type == "GRB") {
            for (var Cnt in BonManagerClass.currentBon) {
                var indexEntry = BonManagerClass.currentBon[Cnt];
                if (indexEntry.type == "CRB" && !indexEntry.cancelled) {
                    var found = true;
                    var CRB = indexEntry.quantity;
                }
            }

            if (!found)
                CRB = 0;

            if (quantity > BonManagerClass.userProps.MaxGlobalRebate - CRB && BonManagerClass.displayMode != "purchase" && !isInstantRebate) {
                text = POS.lang.getText("MESSAGES", "TOO_HIGH_USER_REBATE");
                text += float2StringD2((BonManagerClass.userProps.MaxGlobalRebate - CRB) * 100) +
                "%.";
                POS.message.show(text, "warning", "OK");
                defret.resolve();
                def.reject();
                return 0;
            }
        }

        var RebateText = (inEUR ? (Number(quantity).toFixed(2) + " EUR") : ((quantity * 100).toFixed(2) + " %:"));

        if (updateIt && !quantity) {
            var idx = Entry.index;
            BonManagerClass.currentBon[idx] = null;
            delete BonManagerClass.currentBon[idx];
            $.when(Trans.cancelEntry(Entry)).done(function () {
                def.resolve();
            });
        } else if (updateIt) {
            Entry.quantity = quantity;
            Entry.text1 = text + RebateText; //(inPREC?((quantity * 100).toFixed(2) + " %:"):((quantity).toFixed(2) + " EUR");
            Entry.text2 = (inEUR ? "IDC" : "IRB");
            $.when(Trans.updateEntry(Entry, type)).done(function () {
                def.resolve();
            });
        } else {
            // create BonEntry
            BonManagerClass.currentIndex++;
            // text1
            var text1 = text + (type != "CDS" ? RebateText : "");
            // text2
            var text2 = null;
            if (isPPU)
                text2 = "PPU";
            else if (type == "CDS")
                text2 = refBillId;
            else if (isInstantRebate) {
                text2 = "IRB";
                if (inEUR) {
                    text2 = "IDC";
                }
            }
            //const ref= {dbid:Number(rebid)};    
            PrimBonEntry = new CBonEntry(BonManagerClass.currentIndex, type, "NIL", quantity,
                    text1, text2, null, 0, null, null, true);
            PrimBonEntry.productId=(rebid && Number(rebid)>0 ? rebid: null);
            $.when(PrimBonEntry.defreturn).done(function (c) {
                // Add BonEntry to Bon
                BonManagerClass.currentBon[BonManagerClass.currentIndex] = PrimBonEntry;
                $.when(Trans.addEntry(BonManagerClass.currentBonId, PrimBonEntry)).done(function (id) {
                    def.resolve();
                });
            });
        }
    });
    $.when(def).done(function () {
        if (BonManagerClass.Bon) {
            $.when(BonManagerClass.redrawBonSum()).done(function () {
                BonManagerClass.showSum();
                defret.resolve();
            });
        } else {
            defret.resolve();
        }

    });
    return defret.promise();
}

CRebateEngine.prototype.loadSuggestion = function (type, param1, prodId, prodName, unit) {
    this.Main.InfoIcons.clearLastSuggestionTimeout();
    this.Main.InfoIcons.highlightIcon("suggestion", this.Main.UID); // , 5000);  Should there be a timeout?

    this.suggestionParams = new Array("type", "param1", "prodId", "prodName", "unit");
    this.suggestionParams.type = type;
    this.suggestionParams.param1 = param1;
    this.suggestionParams.prodId = prodId;
    this.suggestionParams.prodName = prodName;
    this.suggestionParams.unit = unit;
}

CRebateEngine.prototype.acceptSuggestion = function () {
    switch (this.suggestionParams.type) {
    case "scale":
        var scale = this.suggestionParams.param1;
        var text = POS.lang.getText("MESSAGES", "SCALE_SUGGESTION_1") +
            this.suggestionParams.unit + "&nbsp;'" +
            this.suggestionParams.prodName + "'&nbsp;" +
            POS.lang.getText("MESSAGES", "SCALE_SUGGESTION_2") + "&nbsp;"
            remAmericanComma(scale) +
            POS.lang.getText("MESSAGES", "SCALE_SUGGESTION_3");
        POS.message.show(text, "info", "YESNO", this, this.doScaleSuggestion);
        break;
    }
}

CRebateEngine.prototype.doScaleSuggestion = function (me, result) {

    me.Main.InfoIcons.hideIcon("suggestion");

    if (result != "YES")
        return;

    me.preAddEntryPOS(1, me.suggestionParams.prodId);
}

CRebateEngine.prototype.checkForRebateChanges = function (weekDay, halfHour, hours, minutes) {
    var BonManagerClass = this;
    $.when(Trans.getAllRebates()).then(function (rebates) {
        var changingRebates = new Array("rebateNames", "rebateEvents");
        changingRebates.rebateNames = new Array();
        changingRebates.rebateEvents = new Array();

        var ind = 0;

        for (var reb in rebates) {
            var statusNow = rebates[reb].timeGrid[weekDay][halfHour];
            if (halfHour + 1 == 48) {
                halfHour = -1;
                weekDay = (weekDay + 1) - ((weekDay + 1) == 7 ? 7 : 0);
            }
            var statusLater = rebates[reb].timeGrid[weekDay][halfHour + 1];

            if (statusNow != statusLater) {
                changingRebates.rebateNames[ind] = rebates[reb].name;
                if (!statusLater)
                    var event = "out";
                else
                    var event = "in";

                changingRebates.rebateEvents[ind] = event;

                ind++;
            }
        }

        if (!changingRebates.rebateNames.length) {
            BonManagerClass.Main.InfoIcons.hideIcon("rebate");
            return;
        }

        BonManagerClass.Main.InfoIcons.highlightIcon("rebate", BonManagerClass.Main.UID);
        BonManagerClass.Main.InfoIcons.changingRebates = changingRebates;
        BonManagerClass.Main.InfoIcons.hours = hours;
        BonManagerClass.Main.InfoIcons.minutes = minutes;
    });
}

CRebateEngine.prototype.recalcAll = function () {
    var me = this;

    var keys = Object.keys(this.currentBon);
    var defret = $.Deferred();
    var iterator = function it(i) {
        if (i < keys.length) {
            var key = keys[i];
            var def = me.recalcAuto(me.currentBon[key]);
            $.when(def).then(function () {
                iterator(i + 1);
                return;
            });
        } else {
            defret.resolve();
            return;
        }
    };
    iterator(0);
    return defret.promise();
}

CRebateEngine.prototype.recalcAuto = function (Entry) {

    var BonManagerClass = this;
    var defret = $.Deferred();
    // Collect the rebates from Entry
    if (!Entry || !Entry.product) {
        log.add(1, "Warning", "No recalc reference!");
        return 0;
    }
    if (Entry.type == "POS")
        var def = Trans.getProductData(Entry.productId);
    else {
        def = Trans.getFreeProductData(Entry.productId);
    }

    // Drei ineinander verschachtelte, aber jetzt einzeln benannte rekursive
    // Iteratoren statt anonymer "function it(i){...}"-Closures (spiegeln
    // echte Schleifenlogik wider - ueber Produkt-Rabatte, dann ueber
    // passende Bon-Positionen, dann ueber deren bestehende Sub-Eintraege -
    // bleiben deshalb rekursiv statt zu einer linearen Kette umgebaut).
    // Werte, die zwischen den Ebenen weitergereicht werden muessen
    // (Rebate/Data/percentage/BEntry/rebateAmount), werden jetzt explizit
    // als Parameter durchgereicht statt implizit ueber Closures - jeder
    // Ausdruck/jede Bedingung wortwoertlich aus der vorherigen Fassung
    // uebernommen.

    function subEntryIterator(BEntry, Rebate, Data, percentage, rebateAmount, ts, j, updateSoFar, onDone) {
        if (j < ts.length) {
            var t = ts[j];
            var SubEntry = BEntry.referencedBy[t];
            if (SubEntry.type == "ARB" && !SubEntry.cancelled &&
                SubEntry.productId == Rebate) {
                var def4 = $.Deferred();
                if (SubEntry.amount != rebateAmount) {

                    if (rebateAmount == 0) {
                        var r = Trans.cancelEntry(SubEntry, "AUT");
                        var idx = SubEntry.index;
                        BonManagerClass.currentBon[idx] = null;
                        delete BonManagerClass.currentBon[idx];
                        delete BEntry.referencedBy[t];
                        $.when(r).done(function () {
                            BonManagerClass.redrawBonArray[BEntry.index] = BEntry;
                            def4.resolve();
                        });
                    } else {
                        SubEntry.text1 = Data.name + " " + float2StringD2(percentage * 100) + "%";
                        SubEntry.amount = rebateAmount;
                        $.when(Trans.updateEntry(SubEntry, "AUT")).done(function () {
                            BonManagerClass.redrawBonArray[BEntry.index] = BEntry;
                            def4.resolve();
                        });
                    }
                } else {
                    def4 = 0;
                }
                $.when(def4).done(function () {
                    subEntryIterator(BEntry, Rebate, Data, percentage, rebateAmount, ts, j + 1, true, onDone);
                    return;
                });
            } else {
                subEntryIterator(BEntry, Rebate, Data, percentage, rebateAmount, ts, j + 1, updateSoFar, onDone);
                return;
            }
        } else {
            onDone(updateSoFar);
            return;
        }
    }

    function entryIterator(BEntryCnts, k, Rebate, Data, percentage, onAllEntriesDone) {
        if (k < BEntryCnts.length) {
            var BEntryCnt = BEntryCnts[k];
            if (!(BEntryCnt in BonManagerClass.currentBon)) {
                entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                return;
            }

            var BEntry = BonManagerClass.currentBon[BEntryCnt];

            if (BEntry.type == "POS" && !BEntry.cancelled &&
                Rebate in BEntry.product.rebates) {
                var rebateAmount = fix2Decimals(BEntry.amount * percentage * -1);
                var rebStr = float2StringD2(rebateAmount);
                while (rebStr[rebStr.length - 1] != 0 && rebStr[rebStr.length - 1] != 5) {
                    rebateAmount -= 0.01;
                    rebStr = float2StringD2(rebateAmount);
                }

                // Search if Rebates already exist
                var ts = Object.keys(BEntry.referencedBy);
                subEntryIterator(BEntry, Rebate, Data, percentage, rebateAmount, ts, 0, false, function (update) {

                    if (rebateAmount == 0) {
                        entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                        return;
                    }

                    // No Rebates -> Add new
                    if (!update) {
                        var hasOtherRebate = false;
                        for (var rbk in BEntry.referencedBy) {
                            var rb = BEntry.referencedBy[rbk];
                            if (rb && !rb.cancelled && (rb.type == "MRB" || rb.type == "ARB")) { hasOtherRebate = true; break; }
                        }
                        if (hasOtherRebate) {
                            log.add(4, "Info", "recalcAuto", "Skipped auto-rebate " + Rebate + " on BONE " + BEntry.BONE_ID + " - position already has a rebate");
                            entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                            return;
                        }
                        // create BonEntry
                        BonManagerClass.currentIndex++;
                        var SecBonEntry = new CBonEntry(BonManagerClass.currentIndex, "ARB", "NIL", null,
                                Data.name + " " + float2StringD2(percentage * 100) + "%", "",
                                BEntry, rebateAmount, null, null);
                        $.when(SecBonEntry.defreturn).done(function (c) {
                            SecBonEntry.productId = Rebate;
                            BonManagerClass.currentBon[BonManagerClass.currentIndex] = SecBonEntry;
                            BEntry.referencedBy[BonManagerClass.currentIndex] = SecBonEntry;
                            $.when(Trans.addEntry(BonManagerClass.currentBonId, SecBonEntry)).done(function () {
                                BonManagerClass.redrawBonArray[BEntry.index] = BEntry;
                                entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                                return;
                            });
                        });
                    } else {
                        entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                        return;
                    }
                });
            } else { //else if BEntry
                entryIterator(BEntryCnts, k + 1, Rebate, Data, percentage, onAllEntriesDone);
                return;
            }
        } else { //else it2 length
            onAllEntriesDone(); //wenn it2 fertig dann naechster it
            return;
        }
    }

    function rebateIterator(Product, Rebatess, i) {
        if (i < Rebatess.length) {
            var Rebate = Rebatess[i];
            var Data = Product.rebates[Rebate];

            var useIt = true;

            // In case the rebate can only be activated through a barcode, check if it was scanned
            if (Data.fromBarcode) {
                var useIt = false;
                for (var j = 0; j < BonManagerClass.activeRebatesFromBarcode.length; j++) {
                    var rebParts = Data.fromBarcode.split("#");
                    var rebBarcode = rebParts[0];
                    if (rebBarcode == BonManagerClass.activeRebatesFromBarcode[j])
                        useIt = true;
                }
            }

            // case: the rebate can only be used by customers with card
            if (Data.onlyCust && !BonManagerClass.currentCustomerId)
                useIt = false;

            if (!useIt) {
                rebateIterator(Product, Rebatess, i + 1);
                return;
            }

            // check time validity
            var now = new Date();
            var day = now.getDay() - 1;
            if (day < 0)
                day = 6;
            var halfHour = now.getHours() * 2 + (now.getMinutes() > 29 ? 1 : 0);
            var Ts = now / 1000;
            var grid = (day + 1) * halfHour;
            var isTimeGrid = Boolean(Data.timeGrid[day][halfHour + 1]);

            useIt = isTimeGrid && Data.start <= Ts && Data.end >= Ts;

            if (!useIt) {
                rebateIterator(Product, Rebatess, i + 1);
                return;
            }

            var Qty = 0;
            // Accumulate Quantity
            for (var BEntryCnt in BonManagerClass.currentBon) {
                var BEntry = BonManagerClass.currentBon[BEntryCnt];

                if (BEntry.type == "POS" && !BEntry.cancelled &&
                    Rebate in BEntry.product.rebates) {
                    Qty += BEntry.quantity;
                }
            }

            // Quantity calculated
            // Now we know the overall quantity and set the Rebates to be used
            var scale;
            var percentage = 0;
            for (var Cnt in Data.scale) {
                scale = Data.scale[Cnt];
                if (Cnt <= Qty)
                    percentage = scale;
                else if (Cnt <= Qty + 1)
                    BonManagerClass.loadSuggestion("scale", scale, Product.prodId, Product.text1, Product.unit);
                else
                    break;
            }

            var BEntryCnts = Object.keys(BonManagerClass.currentBon);
            entryIterator(BEntryCnts, 0, Rebate, Data, percentage, function () {
                rebateIterator(Product, Rebatess, i + 1);
            });
        } else { //iterator if
            defret.resolve();
            return;
        }
    }

    $.when(def).done(function (Product) {
        if (!Product.valid) {
            log.add(1, "Warning", "recalcAuto - no valid product!");
            defret.resolve();
            return;
        }
        // Iterate through Rebates
        BonManagerClass.isReclamationBon = false;

        if (Product.rebates) {
            var Rebatess = Object.keys(Product.rebates);
            rebateIterator(Product, Rebatess, 0);
        } else {
            defret.resolve();
        }
    });
    return defret.promise();
}

CRebateEngine.prototype.redrawBonSumAddRebate = function (drawmode, type, baseval, text, toPrinter) {
    var Changed = false;
    var defret = $.Deferred();
    var BonManagerClass = this;
    var cnts = Object.keys(this.currentBon);
    var iterator = function it(i) {
        if (i < cnts.length) {
            var Cnt = cnts[i];

            var Entry = BonManagerClass.currentBon[Cnt];
            if (Entry.type == type && !Entry.cancelled) {
                var corrPerc = float2StringD2(Entry.quantity * 100);
                if (type != "CDS")
                    if (Entry.text2 == "IDC") { //absoluter EUR Rabatt
                        var corrAmt = -1 * Entry.quantity;
                    } else {
                        var corrAmt = -1 * (baseval - fix2Decimals(((1 - Entry.quantity) * baseval)));
                    }
                else
                    var corrAmt = -1 * Entry.quantity;
                if (!drawmode) {
                    if (Entry.amount != corrAmt) {
                        Entry.amount = corrAmt;
                        $.when(Trans.updateEntry(Entry, "AUT")).done(function () {
                            Changed = true;
                            iterator(i + 1);
                            return;
                        });
                    } else {
                        iterator(i + 1);
                        return;
                    }
                } else {
                    if (Entry.text2 == "PPU")
                        var textToBon = "PK-Rabatt";
                    else if (type == "CDS")
                        textToBon = text;
                    else {
                        if (Entry.text2 == "IDC") { //absoluter EUR Rabatt
                            textToBon = text + " " + Entry.quantity + " EUR";
                        } else {
                            textToBon = text + " " + corrPerc + "%:";
                        }
                    }
                    corrAmt = fix2Decimals(corrAmt);
                    if (BonManagerClass.isPostCancelled)
                        var amount = float2StringD2(Math.abs(corrAmt));
                    else
                        amount = float2StringD2(corrAmt);

                    if (type == "GRB" && BonManagerClass.currentIRBSum > 0) {
                        if (Entry.text2 == "IDC") { //absoluter EUR Rabatt
                            var rebateText = POS.lang.getText("LABELS", "REBATE") + ":";
                            var IRBSumText = float2StringD2(BonManagerClass.currentIRBSum) + "";
                            BonManagerClass.addSumRawLine(rebateText, "", "", amount + " &euro;", toPrinter, 0, false, 1, "A");
                        } else {
                            var rebateText = POS.lang.getText("LABELS", "REBATE") + " " + float2StringD2(BonManagerClass.currentIRBPercent) + "%";
                            var IRBSumText = float2StringD2(BonManagerClass.currentIRBSum) + "";
                            BonManagerClass.addSumRawLine(rebateText, POS.lang.getText("LABELS", "OF"), IRBSumText, amount + " &euro;", toPrinter, 0, false, 1, "A");
                        }

                        iterator(i + 1);
                    } else if (type == "CDS") {

                        $.when(Trans.getPosREGId(Entry.text2)).done(function (POSREG_ID) {
                            if ((!POSREG_ID) || (!BonManagerClass.isCashPayment())) {
                                POSREG_ID = Entry.text2;
                            }
                            BonManagerClass.addSumRawLine(textToBon, "Rechn.nr.:", POSREG_ID, amount + " &euro;", toPrinter, 0, false, 1, "A");
                            iterator(i + 1);
                        });
                    } else {
                        BonManagerClass.addSumRawLine(textToBon, "", "", amount + " &euro;", toPrinter, 0, false, 1, "A");
                        iterator(i + 1);
                    }
                }

                return;
            } else {
                iterator(i + 1);
                return;
            }
        } else {
            defret.resolve(Changed);
            return;
        }
    }
    iterator(0);

    return defret.promise();
}

CRebateEngine.prototype.grantRebPercent = function (percentage, superBonId, Name) {
    var Entry = this.getSelectedItem();
    if (!Entry)
        return 0;
    if (this.isPPCCharge(Entry)) {
        return 0;
    }
    return this.addEntryMRB(Entry, percentage, -1, superBonId, Name);
}

CRebateEngine.prototype.grantRebPercentFromTotal = function (percentage, superBonId, Name) {

    var BonManagerClass = this;
    var defret = $.Deferred();
    $.when(this.extractRebateSum()).then(function (rebSum) {

        BonManagerClass.currentIRBSum = rebSum;
        BonManagerClass.currentIRBPercent = percentage * 100;
        var absReb = rebSum - fix2Decimals(rebSum * (1 - percentage));
        var bonSum = BonManagerClass.getSumArray()[1];
        var relReb = absReb / bonSum;
        if (isNaN(relReb))
            relReb = 0;
        $.when(BonManagerClass.addEntrySubREBS("IRB", relReb, null, null, "PERC",superBonId)).then(function () {
            defret.resolve();
            return;
        });
    });
    return defret.promise();
}

CRebateEngine.prototype.grantRebAbsolute = function (amount, is33, superBonId, Name) {
    var Entry = this.getSelectedItem();
    if (!Entry)
        return 0;
    if (is33) {}
    else {
        if (this.isPPCCharge()) {
            return 0;
        }
    }
    return this.addEntryMRB(Entry, -1, amount, superBonId, Name);
}

CRebateEngine.prototype.grantRebAbsoluteFromTotal = function (amount, is33, superBonId, Name) {
    var BonManagerClass = this;
    var defret = $.Deferred();
    $.when(this.extractRebateSum()).then(function (rebSum) {

        BonManagerClass.currentIRBSum = rebSum;
        BonManagerClass.currentIRBPercent = amount;
        var bonSum = BonManagerClass.getSumArray()[1];
        var relReb = amount;
        if (isNaN(relReb))
            relReb = 0;
        $.when(BonManagerClass.addEntrySubREBS("IRB", relReb, null, null, "EUR",superBonId)).then(function () {
            defret.resolve();
            return;
        });
    });
    return defret.promise();
}

export { CRebateEngine };
